import app from '../../scripts/app';
import template from './jk-preview-typeahead.jade';
import quartersDict from '../../scripts/enums/deadline-quarter';
import materialTypeDict from '../../scripts/enums/material-type';
import { getUndergroundDistance } from '../../scripts/services/geo.service';

function getQuarterValue(value) {
  const quarter = quartersDict.find(item => item.key === value);
  if (quarter) {
    return quarter.numberValue;
  }
};

function getMaterialType(value) {
  const material = materialTypeDict.find(item => item.key === value);
  if (material) {
    return material.name;
  }
}

app.directive('cianAfJkPreviewTypeahead', () => {
  return {
    template,
    scope: {},
    bindToController: {
      item: '='
    },
    controller: [function() {
      this.heading = this.item.name;
      this.address = this.item.geo.address;
      this.developer = this.item.builders;

      this.undergrounds = this.item.geo.underground.map(underground => {
        const undergroundDistance = getUndergroundDistance(underground);

        return {
          ...underground,
          lineColor: underground.color,
          ...undergroundDistance,
        };
      });

      if (this.item.photos && this.item.photos.length) {
        const photo = this.item.photos.find(item => item.isDefault) || this.item.photos[0];
        this.photo = photo.miniUrl;
      }

      const houses = this.item.houses || [];
      const floorsRange = houses.map(house => house.floorsCount).filter(floors => floors);
      if (floorsRange.length) {
        const floorMin = Math.min.apply(null, floorsRange);
        const floorMax = Math.max.apply(null, floorsRange);
        if (floorMin && floorMin === floorMax) {
          this.floors = floorMin;
        } else if (floorMin && floorMax) {
          this.floors = `${floorMin}-${floorMax}`;
        }
      }

      const finishYearRange = houses.map(house => ({
        year: house.finishYear,
        quarter: house.finishQuarter
      })).filter(item => item.year);

      if (finishYearRange.length) {
        const finishYearsOnlyRange = finishYearRange.map(item => item.year);
        const finishYearMin = Math.min.apply(null, finishYearsOnlyRange);
        const finishYearMax = Math.max.apply(null, finishYearsOnlyRange);
        if (finishYearMin && finishYearMin === finishYearMax) {
          this.finishYear = finishYearMin;

          const quarters = finishYearRange.map(item => getQuarterValue(item.quarter)).filter(item => item);
          if (quarters.length) {
            const quarterMin = Math.min.apply(null, quarters);
            const quarterMax = Math.max.apply(null, quarters);

            if (quarterMin && quarterMin === quarterMax) {
              this.finishQuarter = quarterMin;
            } else if (quarterMin && quarterMax) {
              this.finishQuarter = `${quarterMin}-${quarterMax}`;
            }
          }
        } else if (finishYearMin && finishYearMax) {
          this.finishYear = `${finishYearMin}-${finishYearMax}`;
        }
      }

      const materialTypeRange = houses.map(item => getMaterialType(item.materialType)).filter(item => item);
      if (materialTypeRange.length) {
        const materialTypeRangeUnique = [...new Set(materialTypeRange)];
        this.buildingMaterial = materialTypeRangeUnique.join(', ');
      }
    }],
    controllerAs: 'jkPreviewCtrl',
  };
});
